import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import { Link } from 'react-router-dom'

import './Verification.sass'

const Verification = () => {
  return (
    <div id="verification" className="page split">
      <header className="item left" id="login-header" />
      <section className="item right" id="register-content">
        <div className="wrapper">
          <img src="images/logo.png" alt="logo" />
          <div className="verification-info">
            <h2>
              <FormattedMessage id="verification.title" />
            </h2>
            <p>
              <MarkdownMessage id="verification.text" />
            </p>
            <Link className="button filled" to="/">
              <FormattedMessage id="accept" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Verification
